import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=54c7d68e&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7d68e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c7d68e')) {
      api.createRecord('54c7d68e', component.options)
    } else {
      api.reload('54c7d68e', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=54c7d68e&scoped=true&", function () {
      api.rerender('54c7d68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29oJ7h50f39IZ/JS/comp/Voucher-Unit.vue"
export default component.exports